import "lib/mods";
import { PermissionType } from "auth";
import * as businessObjType from "enums/businessObjType";
import * as log from "lib/log";
import * as permissionType from "enums/permissionType";
import { UserPermissionDTO } from "models";

export class BusinessObj extends UserPermissionDTO {
	private numAdminPerms = 4;

	PermissionType(): PermissionType {
		const permCount = [
			this.canCreate,
			this.canRead,
			this.canUpdate,
			this.canDelete,
		]
			.Map(Number)
			.Sum();
		if (permCount === this.numAdminPerms) {
			return permissionType.Admin();
		}
		return permissionType.ReadOnly();
	}

	private get businessObjTypeString(): string {
		const [, objectId] = this.id.Split(".");
		return objectId;
	}

	private get businessObjType(): businessObjType.BusinessObjType {
		const objectId = this.businessObjTypeString;
		// Use dynamic creation - works with any objectId from database
		return businessObjType.CreateBusinessObjType(objectId);
	}

	get Name(): string {
		return this.businessObject?.name ?? "";
	}

	get SectorName(): string {
		return this.sectorName ?? "";
	}

	GetBusinessObjType(): businessObjType.BusinessObjType {
		return this.businessObjType;
	}
	
	GetBusinessObjTypeString(): string {
		return this.businessObjTypeString;
	}
	
}
